import { useState } from 'react';
import styles from './ShareScenario.module.css';
import { clipboardIcon, shareIcon } from '../../assets/icons';
import { ScenarioDefinitionType } from '../../api/scenarioDefinitions';

interface ShareScenarioProps {
  scenarioDefinition: ScenarioDefinitionType; // The scenario definition to share (required)
}

function ShareScenario({ scenarioDefinition }: ShareScenarioProps): JSX.Element {
  const [showNotification, setShowNotification] = useState(false);

  const handleShareClick = () => {
    // Construct the URL using the scenario definition ID
    const shareUrl = `${window.location.origin}/scenarios/${scenarioDefinition.id}`;
    
    navigator.clipboard.writeText(shareUrl)
      .then(() => {
        setShowNotification(true);
        setTimeout(() => {
          setShowNotification(false);
        }, 3000);
      })
      .catch((error) => {
        console.error('Failed to copy URL:', error);
      });
  };

  return (
    <>
      <div className={styles.shareButtonContainer}>
        <button 
          className={styles.shareButton} 
          onClick={handleShareClick}
          aria-label="Share scenario"
        >
          <img src={shareIcon} alt="Share" className={styles.shareIcon} />
        </button>
      </div>

      {showNotification && (
        <div className={styles.notification}>
          <img src={clipboardIcon} alt="Copied" className={styles.notificationIcon} />
          <span>URL copied to clipboard</span>
        </div>
      )}
    </>
  );
}

export default ShareScenario; 